'use strict';

exports = module.exports = {
  // List of user roles
  userRoles: ['guest', 'user', 'moderator', 'admin']
};



//////////////////
// WEBPACK FOOTER
// ./server/config/environment/shared.js
// module id = 167
// module chunks = 0